import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'services/api';

const initialState = {
  status: 'idle',
  items: [],
  unreadCount: 0,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    notificationsLoading(state) {
      state.status = 'loading';
    },
    notificationsLoaded(state, action) {
      state.items = action.payload.notifications;
      state.unreadCount = action.payload.unreadCount;
      state.status = 'idle';
    },
    notificationMarkedRead(state, action) {
      state.items = state.items.map((item) => (item.id === action.payload ? { ...item, isRead: true } : item));
      state.unreadCount = Math.max(0, state.unreadCount - 1);
    },
    notificationsMarkedRead(state) {
      state.items = state.items.map((item) => ({ ...item, isRead: true }));
      state.unreadCount = 0;
    },
  },
});

export const { notificationsLoading, notificationsLoaded, notificationMarkedRead, notificationsMarkedRead } = notificationSlice.actions;

export const fetchNotifications = () => async (dispatch) => {
  dispatch(notificationsLoading());
  try {
    const response = await apiClient.get('/notifications');
    dispatch(notificationsLoaded(response.data.data));
  } catch {
    dispatch(notificationsLoaded({ notifications: [], unreadCount: 0 }));
  }
};

export const markNotificationRead = (notificationId) => async (dispatch) => {
  await apiClient.put(`/notifications/${notificationId}/read`);
  dispatch(notificationMarkedRead(notificationId));
};

export const markAllNotificationsRead = () => async (dispatch) => {
  await apiClient.put('/notifications/read-all');
  dispatch(notificationsMarkedRead());
};

const notificationReducer = notificationSlice.reducer;
export default notificationReducer;
